import React from 'react'
import heroImage from '../../../assets/img/hero.svg'
import HeroText from './HeroText'

const HeroTablet: React.FC = () => {
  return (
    <section className="relative w-full h-[820px] bg-black text-white flex flex-col items-center justify-start pt-[108px] px-4 overflow-visible">
      <div className="w-full max-w-[456px] flex flex-col items-center justify-center z-10 mb-8">
        <HeroText />
      </div>
      
      <div className="w-full max-w-[456px] flex items-center justify-center z-20">
        <img 
          src={heroImage} 
          alt="Zuchy book characters" 
          className="w-full max-w-full object-contain"
        />
      </div>
    </section>
  )
}

export default HeroTablet
